<template>
  <div>
    <div v-if="!uploading" class="js-upload uk-width-1-1" uk-form-custom>
      <input type="file" aria-label="Attach a file" @change="onFilePicked" />
      <button
        class="uk-button uk-button-default uk-width-1-1"
        type="button"
        tabindex="-1"
      >
        <span
          v-if="!uploading"
          class="uk-margin-small-right"
          uk-icon="upload"
        ></span
        >Attach a File
      </button>
    </div>
    <button
      v-if="uploading"
      class="uk-button uk-button-default uk-width-1-1"
      type="button"
      tabindex="-1"
      disabled
    >
      <div uk-spinner></div>
      Uploading ({{ uploadProgress }}%)
    </button>
    <p
      v-if="badExtension"
      class="uk-text-center uk-width-1-2@m uk-align-center uk-margin-small-top uk-text-warning"
    >
      File must be .ai, .eps, .svg, .pdf, .png, or .jpg
    </p>
  </div>
</template>

<script>
import firebase from "firebase";
import _ from "lodash";

export default {
  name: "ImageUpload",
  props: { destination: { type: String, required: true } },
  data() {
    return {
      badExtension: false,
      uploading: false,
      uploadProgress: 0
    };
  },
  computed: {},
  mounted() {},
  methods: {
    removeFile(index) {
      this.tempUploadedFiles.splice(index, 1);
    },
    onFilePicked(event) {
      var self = this;
      self.badExtension = false;
      let fileDeatils = {
        originalName: "",
        newName: "",
        extension: "",
        downloadURL: "",
        canPreview: false
      };
      const files = event.target.files;
      let filename = files[0].name;
      fileDeatils.originalName = filename;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Please add a valid file!");
      }

      let splitFileName = _.split(filename, ".");
      let filenameNoExtension = "";
      let extension = "";
      if (splitFileName.length == 2) {
        filenameNoExtension = splitFileName[0];
        extension = splitFileName[1];
      } else {
        for (let index = 0; index < splitFileName.length - 1; index++) {
          const element = splitFileName[index];
          filenameNoExtension = filenameNoExtension.concat(element);
          if (index < splitFileName.length - 1) {
            filenameNoExtension.concat(".");
          }
        }
        extension = splitFileName[splitFileName.length - 1];
      }
      fileDeatils.extension = extension;

      if (!["ai", "svg", "eps", "png", "jpg", "pdf"].includes(extension)) {
        self.badExtension = true;
        return;
      }

      if (["svg", "png", "jpg"].includes(extension)) {
        fileDeatils.canPreview = true;
      }

      //firebase example
      let storageRef = firebase.storage().ref();
      let newName =
        filenameNoExtension + _.random(100000, 999999) + "." + extension;
      fileDeatils.newName = newName;
      let imageRef = storageRef.child(self.destination + "/" + newName);
      let file = files[0];
      let uploadTask = imageRef.put(file);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on(
        firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        function(snapshot) {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          let progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          self.uploadProgress = progress;
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              self.uploading = true;
              break;
          }
        },
        function(error) {
          console.error(error.code);
        },
        function() {
          // Upload completed successfully, now we can get the download URL
          uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
            self.uploading = false;
            self.uploadProgress = 0;
            fileDeatils.downloadURL = downloadURL;
            self.$emit("file-uploaded", downloadURL);
          });
        }
      );
    }
  }
};
</script>

<style type="text/css"></style>



// WEBPACK FOOTER //
// src/components/image-upload/ImageUpload.vue